import type { AddressFragments } from './types';

export const ADDRESS_SEPARATOR = ', ';

export const renderAddress = (address: AddressFragments): string => address.join(ADDRESS_SEPARATOR);
